import type { ColorName, IconName } from "@repo/ui";

export type StageConfig = {
	icon: IconName;
	backgroundColor: ColorName;
	textColor: ColorName;
	borderColor: ColorName;
	label: string;
};

// Ensure adjacent stages use different colors for visual variety
export const stageConfigs: Record<string, StageConfig> = {
	elig: {
		icon: "ShieldCheck",
		backgroundColor: "green3",
		textColor: "green11",
		borderColor: "green7",
		label: "Checking eligibility",
	},
	pcp: {
		icon: "Bot",
		backgroundColor: "indigo3",
		textColor: "indigo11",
		borderColor: "indigo7",
		label: "Verifying PCP information",
	},
	prefs: {
		icon: "MessageSquare",
		backgroundColor: "accent3",
		textColor: "accent11",
		borderColor: "accent7",
		label: "Collecting patient preferences",
	},
	providers: {
		icon: "Search",
		backgroundColor: "amber3",
		textColor: "amber11",
		borderColor: "amber7",
		label: "Searching providers",
	},
	pa: {
		icon: "CircleCheckBig",
		backgroundColor: "sand3",
		textColor: "sand11",
		borderColor: "sand7",
		label: "Processing prior auth",
	},
	attach: {
		icon: "FileText",
		backgroundColor: "blue3",
		textColor: "blue11",
		borderColor: "blue7",
		label: "Attaching medical records",
	},
	send: {
		icon: "ArrowBigRightDash",
		backgroundColor: "indigo3",
		textColor: "indigo11",
		borderColor: "indigo7",
		label: "Sending referral",
	},
	notify: {
		icon: "MessageSquare",
		backgroundColor: "green3",
		textColor: "green11",
		borderColor: "green7",
		label: "Sending message to patient",
	},
	consult: {
		icon: "FileText",
		backgroundColor: "accent3",
		textColor: "accent11",
		borderColor: "accent7",
		label: "Retrieving consult notes",
	},
	ack: {
		icon: "Bot",
		backgroundColor: "amber3",
		textColor: "amber11",
		borderColor: "amber7",
		label: "Waiting for acknowledgment",
	},
	complete: {
		icon: "PhoneCall",
		backgroundColor: "accent3",
		textColor: "accent11",
		borderColor: "accent7",
		label: "Calling providers",
	},
};
